import settingsIcon from "../../assets/home-page/why-genz-paisa/settings-icon.svg";
import slidersIcon from "../../assets/home-page/why-genz-paisa/sliders-icon.svg";
import fileTextIcon from "../../assets/home-page/why-genz-paisa/file-text-icon.svg";
import smartphoneIcon from "../../assets/home-page/why-genz-paisa/smartphone-icon.svg";
import { useInView } from "../../hooks/useInView";

const FEATURES = [
  {
    icon: settingsIcon,
    title: "Simple Process",
    description: "Fully digital workflow, from verification to payout.",
  },
  {
    icon: slidersIcon,
    title: "Flexible Options",
    description: "Tailor your repayment timeline to your paycheck frequency.",
  },
  {
    icon: fileTextIcon,
    title: "Transparent Terms",
    description: "Zero hidden charges or unexpected early foreclosure fees.",
  },
  {
    icon: smartphoneIcon,
    title: "Digital Experience",
    description:
      "Track everything online anytime with a smooth, intuitive dashboard.",
  },
];

export function WhyGenzPaisa() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="w-full bg-[#210d37] px-4 pb-16 pt-10 font-inter sm:pb-20 sm:pt-12 lg:px-20 lg:pb-[100px] lg:pt-16">
      <div
        ref={ref}
        className={`mx-auto flex w-full max-w-[1280px] flex-col items-start gap-10 lg:flex-row lg:gap-20 ${inView ? "in-view" : ""}`}
      >
        {/* Left column */}
        <div className="flex flex-1 flex-col gap-6">
          <span className="reveal-scroll delay-1 text-sm font-bold uppercase text-[#0e767e]">
            Loans made simple. Finances made easier.
          </span>
          <h2 className="reveal-scroll delay-2 font-serif-accent text-4xl font-bold leading-[1.2] text-white sm:text-5xl lg:text-[52px]">
            Why GenzPaisa?
          </h2>
          <p className="reveal-scroll delay-3 text-base leading-[1.6] text-[#f6f4fc]">
            We are redefining borrowing for the modern generation. No waiting
            rooms, no physical branches, and absolutely zero confusing
            finance jargon. Just instant, clean, transparent access to
            capital.
          </p>
        </div>

        {/* Right column */}
        <div className="reveal-scroll delay-4 flex flex-1 flex-col gap-6">
          {FEATURES.map((feature) => (
            <div key={feature.title} className="flex items-center gap-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10 p-3">
                <img src={feature.icon} alt="" className="h-5 w-5" />
              </span>
              <div className="flex flex-col gap-1">
                <p className="font-bold text-white">{feature.title}</p>
                <p className="text-sm text-[#f6f4fc]">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
